<template>
  <v-layout>
    <v-tooltip
      v-for="presentation in presentations"
      :key="presentation.codigo"
      bottom
      color="#192B46"
      :disabled="presentation.status_venda !== 'esgotada'"
    >
      <v-card
        class="py-2 px-3 mr-3"
        slot="activator"
        :id="presentation.codigo"
        outline
        flat
        :style="
          `border-radius: 20px; cursor: ${
            presentation.codigo === eventDetails.codigo
              ? 'default'
              : presentation.status_venda === 'esgotada'
              ? ''
              : 'pointer'
          }; border: 1px solid #eaeaea`
        "
        :color="
          presentation.codigo === eventDetails.codigo
            ? 'primary'
            : presentation.status_venda === 'esgotada'
            ? '#eaeaea'
            : ''
        "
        @click="handleSelectEvent(presentation)"
      >
        <v-flex>
          <v-layout class="justify-center">
            <span
              :style="
                `font-weight: 500; color: ${
                  presentation.codigo === eventDetails.codigo ? 'white' : ''
                }`
              "
            >
              {{
                $moment(presentation.data)
                  .format('dddd')
                  .replace('-feira', '')
              }}
            </span>
          </v-layout>
          <v-layout>
            <span
              :style="
                `font-weight: 500; color: ${
                  presentation.codigo === eventDetails.codigo ? 'white' : ''
                }`
              "
            >
              {{
                $moment(getFormattedDate(presentation)).format('DD/MMM - HH:mm')
              }}
            </span>
          </v-layout>
        </v-flex>
      </v-card>

      <span v-if="presentation.status_venda === 'esgotada'" class="white--text"
        >Esgotado</span
      >
    </v-tooltip>
  </v-layout>
</template>

<script>
export default {
  props: ['eventDetails', 'presentations', 'cartProducts'],

  methods: {
    getFormattedDate(presentation) {
      let splittedDate = `${presentation.data.split(' ')[0]} ${
        presentation.horario_evento
      }:00`;

      return splittedDate;
    },

    handleSelectEvent(date) {
      if (date.status_venda !== 'esgotada') {
        this.$store.commit('SET_SALE_UNINITIATED', '');
        if (date.codigo === this.eventDetails.codigo) return;

        let query = {};

        if (this.$route.query.c) query.c = this.$route.query.c;

        this.$router.push({ params: { id: date.codigo }, query });

        this.$store.commit('SET_EVENT_ID', date.codigo);

        this.reset();
      }
    },

    async reset() {
      const evento = this.$store.getters.eventID;
      const checkoutState =
        JSON.parse(localStorage.getItem(`checkoutState`)) || {};
      this.cartProducts.forEach(product => {
        product.forEach(async el => {
          if (el.seats) {
            el.seats.forEach(async sc => {
              await this.$store.dispatch('unbookPurchaseSeats', sc);
            });
          }
        });
      });

      await this.$store.dispatch('fetchEventData');
      await this.$store.dispatch('deleteCheckoutState', evento);
      if (
        checkoutState &&
        checkoutState[evento] &&
        checkoutState[evento].userToken
      )
        await this.$store.dispatch('getClientData');
      await this.$store.dispatch('loadCheckoutState', evento);
      await this.$store.dispatch('resetSelection');
      await this.$store.dispatch('setResetPurchase', false);
    },
  },
};
</script>
